import isEmptyValue from '../utils/is-empty-value';
export default (({
  message = 'This field is required'
} = {}) => {
  const validate = value => isEmptyValue(value) ? message : null;
  validate.mandatory = true;
  return validate;
});